
import React from 'react'
import * as R from 'ramda'
import Moment from 'moment'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import {List, ListItem} from 'material-ui/List'
import ContentAdd from 'material-ui/svg-icons/content/add'



import OwnerCard from './OwnerCard'

import { sortSev } from 'utils/stuff'

export default (o) => (
	<div
		id="main-content"
		style={{
			marginLeft: (typeof global.md.phone() == 'string')?
					"0"
				: '54px'
		  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"5px":"60px"
		  , overflowY: "auto"
		  , overflowX: 'hidden'
		  , height: "calc(100vh - 60px)"//(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?'calc(100vh - 60px)': (typeof global.md.tablet() == "string")? 'calc(100vh - 168px)' : 'calc(100vh - 109px)'
		  , width: (o.rightStackOpened)? (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?  "100%" : "calc(53% - 53px)" : `calc(100% - ${(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0px" : "53px"})`
		}}
	>
		{(typeof global.md.phone() != 'string')?
			<div
				style={{
					fontSize: "20px"
				  , marginTop: "31px"
				  , color: "#FFF"
				  , position: "fixed"
				  , zIndex: "1000"
				  , top: "-15px"
				  , left: "76px"
				}}
			>
				Owners
			</div>
			: ""
		}
		{/*<AddButton type="owner" object={{
				firstName: ""
			  , companyName: ""
			  , phoneNumber: ""
			  , ownerType: "person"
			  , cellNumber: ""
			  , email: ""
			  , address: ""
			  , checkAddress: ""
			  , iin: ""
			  , note: ''
			  , type: "owner"
			  , properties: []
			  , comments: []
		}}/>*/}
		<List
			style={{
				backgroundColor: "transparent"
			}}
		>
			{(R.keys(o.owners).length)?
				R.map((owner) => (
					<OwnerCard
						key={`project-${owner._id}`}
						owner={owner}
						id={owner._id}
						openPanel={o.openPanel}
						lastInteracted={o.lastInteracted}
					/>
			),  sortSev(o.owners, "firstName", "lastName", "leaseID"))
				: <p style={{marginLeft: "20px", marginTop: "12px",color: "#A0A0A0"}}>No owners</p>
			}
		</List>
	</div>
)
/*{()=> {

}}*/



// WEBPACK FOOTER //
// ./src/routes/manager/owners/OwnersList.js